module.exports = __webpack_public_path__ + "img/example_1.bef290db.png";